/**
 * The action slot of a Settings → Security row (Connected accounts, Two-factor
 * verification): every button there is this wide, full width on phones, and
 * 40px tall to match Google's rendered button, which sets its own height.
 */
export const SETTINGS_ACTION_SLOT = 'w-full sm:w-[240px]';
export const SETTINGS_ACTION_BUTTON = 'h-40 w-full justify-center';
